import { mapBookingParamsFromResponse } from 'apiConnector/secondary-market/cp-order/utils';
import { isDominoGetBookingParamsReport } from 'apiConnector/secondary-market/reports';
import type { Action } from 'state/actions';
import { addOrReplaceKey, patchKey, removeKey } from 'state/utils/collection';

import type { ProductMap } from './product.model';
import { initialProductsMap } from './product.model';

export function productReducer(state: ProductMap = initialProductsMap, action: Action): ProductMap {
  switch (action.type) {
    case 'SECONDARY_MARKET_CP_ORDER_INIT_FORM_FETCH_REQUESTED':
    case 'SECONDARY_MARKET_CP_ORDER_RELOAD_FORM_FETCH_REQUESTED':
      return addOrReplaceKey(state, action.tabId, {
        bcsProduct: undefined,
        dominoProduct: undefined,
        errors: [],
        infos: [],
        warnings: [],
      });
    case 'SECONDARY_MARKET_CP_ORDER_INIT_FORM_FETCHED':
    case 'SECONDARY_MARKET_CP_ORDER_RELOAD_FORM_FETCHED':
      return patchKey(state, action.tabId, () => ({
        dominoProduct: mapBookingParamsFromResponse(action.response.dominoBookingParams),
        bcsProduct: action.response.bcsProduct,
        quantityInfo: action.response.quantityInfo,
        errors: action.response.errors?.filter(isDominoGetBookingParamsReport).map(r => r.payload),
        warnings: action.response.warnings?.filter(isDominoGetBookingParamsReport).map(r => r.payload),
        infos: action.response.infos?.filter(isDominoGetBookingParamsReport).map(r => r.payload),
      }));

    case 'SECONDARY_MARKET_POSTEVENT_WORKSPACE_REMOVE_TAB':
    case 'SECONDARY_MARKET_QUOTES_WORKSPACE_REMOVE_TAB':
      if (action.tabType === 'closePriceOrder') {
        return removeKey(state, action.tabId);
      }
      return state;
    default:
      return state;
  }
}
